import { AttachmentsUpload, Button, Label } from "abs-ui-components";
import { CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";
import { searchWcn } from "../CERHelpers";
import AutocompleteDropdown from "../../../common/autocompleteDropdown/AutocompleteDropdown";
import axiosHttp from "../../../services/interceptor";
import { emitToasterMsg } from "../../../services/toasterUtility";
import xmlImage from "../../../images/xml-document-svgrepo-com.svg";
import "./ImportCERModal.scss"
const ImportCERModal = ({ onClose,reportingYear  }) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [uploadingReport, setUploadingReport] = useState(false);
    const [confirmingReport, setConfirmingReport] = useState(false);
    const [dragged, setDragged] = useState(null);
    const [selectedWcn, setSelectedWcn] = useState(null);
    const [searchWCN, setSearchWCN] = useState("");
    const [reportData, setReportData] = useState(null);
    const [canProceed, setCanProceed] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");


    const getActualFile = (fileInput) => {
        if (!fileInput) return null;

        if (fileInput instanceof File) {
            return fileInput;
        } else if (fileInput?.originFileObj) {
            return fileInput.originFileObj;
        } else if (fileInput?.file) {
            return fileInput.file;
        }
        return fileInput;
    };

    const handleFileUpload = async () => {
        if (!selectedFile) return;

        try {
            setUploadingReport(true);
            const actualFile = getActualFile(selectedFile);
            if (!actualFile) {
                console.error("Could not extract filr object")
            }

            const formData = new FormData();
            formData.append("file", actualFile);

            const response = await axiosHttp.post(
                "/api/CompanyVerification/ReadCompanyEmissionReport",
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            if (response.data?.isSuccess) {
                setReportData(response.data);
                setCanProceed(true);
                setErrorMessage("");

            } else {
                setCanProceed(false);
                setErrorMessage(response.data?.errorMessage ?? "Upload failed");
            }
        } catch (error) {
            console.error(error);
        } finally {
            setUploadingReport(false);
        }
    };
    const handleConfirmReport = async () => {

        // Get the actual file object
        const actualFile = getActualFile(selectedFile);

        if (!actualFile || !selectedWcn?.wcnMappingId) {
            console.error("Missing file or WCN", { actualFile, selectedWcn });
            return;
        }

        try {
            setConfirmingReport(true);

            const formData = new FormData();
            formData.append("file", actualFile);
            formData.append("wcnMstId", selectedWcn.wcnMappingId);

            const response = await axiosHttp.post(
                "/api/CompanyVerification/ConfirmCompanyEmissionReport",
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                    params: {
                        wcnMstId: selectedWcn.wcnMappingId,
                         selectedReportYear: reportingYear || 2024
                    }
                }
            );
            if (response.data?.isSuccess) {
                emitToasterMsg("success", "The xml file is Imported Successfully")
                setErrorMessage("");
                if (onClose) {
                    onClose(true);
                }
            } else {
                emitToasterMsg("failed", "unable to import xml file")
                setErrorMessage(response.data?.errorMessage || "Confirmation failed");
            }

        } catch (error) {
            console.error(error);
        } finally {
            setConfirmingReport(false);
        }
    };

    const handleClear = () => {
        setSelectedFile(null);
        setReportData(null);
        setSelectedWcn(null);
        setCanProceed(false);
        setErrorMessage("");
    };


    const handleRemoveFile = () => {
        setSelectedFile(null);
        setReportData(null);
        setSelectedWcn(null);
        setCanProceed(false);
        setErrorMessage("");
    };

    const onDragOver = (e) => {
        e.preventDefault();
        setDragged(true);
    };

    const onDragLeave = () => {
        setDragged(false);
    };

    const onDrop = (e) => {
        e.preventDefault();
        setDragged(false);
    };


    const handlesearchwcns = async (inputValue) => {
        const response = await searchWcn(inputValue);

        const options = response?.data?.map((item) => ({
            label: `${item.CompanyName}`,
            value: `${item.WcnNumber}`,
            wcnMappingId: item.WcnMstId,
            controlRiskId: item.ControlRiskId,
            inherentRiskId: item.InherentRiskId,
        })) || [];

        return options;
    };
    useEffect(() => {
        const delay = setTimeout(() => {
            handlesearchwcns(searchWCN);
        }, 400); // debounce
        return () => clearTimeout(delay);
    }, [searchWCN]);

    return (
        <div
            onDragOver={onDragOver}
            onDragLeave={onDragLeave}
            onDrop={onDrop}
            className={dragged ? "drag-drop-cls mt-4 ml-4 mr-4 pb-2" : "mt-4 ml-4 mr-4 pb-2"}
        >
            <AttachmentsUpload
                supportedFormat="xml"
                supportedFileTypes=".xml"
                onFilesSelected={(files) => {
                    const file = files?.[0];
                    if (!file) return;
                    const fileName = String(file?.fileName || "");
                    if (!fileName.toLowerCase().endsWith(".xml")) {
                        emitToasterMsg("error", "Only xml files are accepted");
                        return;
                    }
                    setSelectedFile(file);
                }}
            />

            <div className="selected-content mt-4">
                {selectedFile && (
                    <>
                        <div className="mt-3">
                            <div className="d-flex justify-content-between align-items-center px-3 py-1">
                                <div className="d-flex">
                                    {/* Make sure to import xlsxImage or replace with appropriate icon */}
                                    <img
                                        src={xmlImage}
                                        alt="File Icon"
                                        className="xl-img mt-1"
                                    />
                                    <span className="file-name p-2">
                                        {selectedFile?.name || selectedFile?.fileName || 'Selected file'}
                                    </span>
                                </div>
                                <button
                                    type="button"
                                    className="close p-0"
                                    aria-label="Close"
                                    onClick={handleRemoveFile}
                                >
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                        </div>

                        {reportData?.isSuccess && (
                            <div className="d-flex justify-content-between mt-4 g-2">
                                <div className="d-flex g-2">
                                    <Label name="Company IMO Number: " bold /> &nbsp;
                                    <Label name={reportData.companyImoNumber} bold />
                                </div>
                                <div className="d-flex g-2">
                                    <Label name="Reporting Year: " bold />&nbsp;
                                    <Label name={reportData.reportYear} bold />
                                </div>
                            </div>
                        )}

                        <div className="mt-4">
                            {reportData?.isSuccess && (
                                <AutocompleteDropdown
                                    id="management_company_wcn"
                                    loadOptions={handlesearchwcns}
                                    getOptionLabel={(option) => `${option.value} - ${option.label}`}
                                    menuPosition="fixed"
                                    placeholder="Search WCN"
                                    isClearable
                                    onChange={(option) => {
                                        setSelectedWcn(option);
                                    }}
                                />
                            )}
                        </div>
                        <div className="mt-4 d-flex upload-container justify-content-end g-2">
                            {uploadingReport && (
                                <CircularProgress size={30} />
                            )}
                            {!canProceed ? (
                                // Show Upload button when file is not yet uploaded
                                <Button
                                    primaryBackgroundColor={"#DC1E34"}
                                    primaryColor={"#DC1E34"}
                                    onClick={handleFileUpload}
                                    className="ml-2"
                                    disabled={uploadingReport}
                                >
                                    {uploadingReport ? "Uploading..." : "Upload"}
                                </Button>
                            ) : (
                                // Show Proceed button only when WCN is selected
                                selectedWcn ? (
                                    <Button
                                        primaryBackgroundColor={"#DC1E34"}
                                        primaryColor={"#DC1E34"}
                                        onClick={handleConfirmReport}
                                        className="ml-2"
                                        disabled={confirmingReport}
                                    >
                                        {confirmingReport ? "Proceeding..." : "Proceed"}
                                    </Button>
                                ) : (
                                    // Show disabled Proceed button with tooltip or just hide it
                                    <Button
                                        primaryBackgroundColor={"#DC1E34"}
                                        primaryColor={"#DC1E34"}
                                        className="ml-2"
                                        disabled={true}
                                        style={{ opacity: 0.5, cursor: "not-allowed" }}
                                        title="Please select a WCN first"
                                    >
                                        Proceed
                                    </Button>
                                )
                            )}
                            <Button
                                onClick={handleClear}
                                className="ml-2 select-file-color cancel-excel black-text-btn"
									primaryBackgroundColor="#f9f9f9"
									primaryColor="#f9f9f9"
                            >
                                Clear
                            </Button>
                        </div>

                       <div>
                            {errorMessage && (
                                <div className="mt-3 cer-error-table-wrapper">
                                    <div className="mb-2">
                                        One or More errors found with files as below :
                                    </div>
                                    <table className="cer-error-table w-100">
                                        <thead>
                                            <tr>
                                                <th>File Name</th>
                                                <th>Message</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>{selectedFile?.name || selectedFile?.fileName || "-"}</td>
                                                <td className="text-danger">{errorMessage}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>

                    </>
                )}
            </div>
        </div>
    );
};

export default ImportCERModal;